module.exports = __webpack_public_path__ + "media/images/pets6-e975f60e50be11ae0d7cc7eb2636999d.jpg";